import { all } from "redux-saga/effects"
import authSagas from "./auth/saga"
import userSagas from "./user/sagas"
import schoolSagas from "./school/sagas"
import courseSagas from "./courses/saga"

const callEachFunction = (x) => x()

export default function* (dispatch) {
  yield all([
    ...authSagas.map(callEachFunction),
    ...userSagas.map(callEachFunction),
    ...schoolSagas.map(callEachFunction),
    ...courseSagas.map(callEachFunction),
  ])
}
